export function Camera() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M9.98164 3H15.0184C15.8674 3 16.618 3.54223 16.8846 4.34613L17.3111 5.625H20.375C21.8229 5.625 23 6.80215 23 8.25V18.75C23 20.1979 21.8229 21.375 20.375 21.375H4.625C3.1751 21.375 2 20.1979 2 18.75V8.25C2 6.80215 3.1751 5.625 4.625 5.625H7.68887L8.11543 4.34613C8.38203 3.54223 9.13262 3 9.98164 3ZM12.5 17.4375C14.6738 17.4375 16.4375 15.6738 16.4375 13.5C16.4375 11.2893 14.6738 9.5625 12.5 9.5625C10.2893 9.5625 8.5625 11.2893 8.5625 13.5C8.5625 15.6738 10.2893 17.4375 12.5 17.4375Z" />
    </svg>
  );
}
